import React from 'react';

import { classnames, useClassnames } from '@lumapps/classnames';
import { Button, ButtonProps, Emphasis } from '@lumapps/lumx/react';

import './index.scss';

const CLASSNAME = 'reaction-button';

export const ReactionButton = React.forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
    const { className, emphasis = Emphasis.low, children, isDisabled, ...forwardedProps } = props;
    const { block } = useClassnames(CLASSNAME);
    // `aria-disabled` covers the transient states that must stay focusable (see `ReactButton`).
    const isAnyDisabled = Boolean(isDisabled || forwardedProps['aria-disabled']);
    return (
        <Button
            ref={ref}
            className={classnames(className, block({ 'is-disabled': isAnyDisabled }))}
            isDisabled={isDisabled}
            emphasis={emphasis}
            {...forwardedProps}
        >
            {children}
        </Button>
    );
});
